import script from "./AlertToast.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertToast.vue?vue&type=script&setup=true&lang=js"

import "./AlertToast.vue?vue&type=style&index=0&id=40194e92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40194e92"]])

export default __exports__